import styled from 'styled-components';
import React from 'react';

const Bar = styled.span.withConfig({
  displayName: "styled__Bar",
  componentId: "sc-45lonn-0"
})(["background:", ";display:block;width:24px;height:4px;border-radius:2px;+ span{margin-top:4px;}"], ({
  theme
}) => theme.palette.secondary.main);
const Button = styled.button.withConfig({
  displayName: "styled__Button",
  componentId: "sc-45lonn-1"
})(["position:relative;float:right;padding:9px 10px;margin-top:18px;margin-right:0;margin-bottom:8px;background-color:transparent;background-image:none;border:none;border-radius:4px;&:focus{background-color:white;outline:none;}"]);
const ScreenReaderOnly = styled.span.withConfig({
  displayName: "styled__ScreenReaderOnly",
  componentId: "sc-45lonn-2"
})(["position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0;"]);

const Hamburger = ({
  onClick
}) => /*#__PURE__*/React.createElement(Button, {
  onClick: onClick,
  type: "button"
}, /*#__PURE__*/React.createElement(ScreenReaderOnly, null, "Toggle navigation"), /*#__PURE__*/React.createElement(Bar, null), /*#__PURE__*/React.createElement(Bar, null), /*#__PURE__*/React.createElement(Bar, null));

export { Hamburger as H };
